// ATHL8: quick-add for cart cross-sell cards.
// Submits the +TOEVOEGEN form via fetch, then refreshes the cart drawer.
// build: cross-sell-fix-3
(function () {
  console.info('[cart-quick-add] script loaded. Build: cross-sell-fix-3');
  function flashFailure(btn) {
    if (!btn) return;
    var original = btn.dataset.originalLabel || '+ TOEVOEGEN';
    btn.disabled = false;
    btn.textContent = 'NIET GELUKT';
    btn.classList.add('cart-cross-card__add--failed');
    setTimeout(function () {
      btn.textContent = original;
      btn.classList.remove('cart-cross-card__add--failed');
    }, 2000);
  }

  function bind(form) {
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      console.info('[cart-quick-add] submit intercepted', { variantId: form.querySelector('[name=id]') && form.querySelector('[name=id]').value });
      var btn = form.querySelector('.cart-cross-card__add');
      if (btn) {
        btn.dataset.originalLabel = btn.dataset.originalLabel || btn.textContent;
        btn.disabled = true;
        btn.textContent = 'BEZIG…';
      }

      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            console.error('[cart-quick-add] /cart/add.js failed:', res.status, res.body);
            flashFailure(btn);
            return;
          }
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.originalLabel || '+ TOEVOEGEN';
          }
          console.info('[cart-quick-add] add succeeded; dispatching refresh', res.body);
          // Refresh the cart drawer (the existing CartDrawer listens for this)
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        })
        .catch(function (err) {
          console.error('[cart-quick-add] network error submitting form:', err);
          flashFailure(btn);
        });
    });
  }

  function init(root) {
    var forms = (root || document).querySelectorAll('[data-cart-quick-add]');
    console.info('[cart-quick-add] init: binding', forms.length, 'forms');
    forms.forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('on:cart:after-merge', function () { init(); });
})();
